import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UserManagementComponent } from "src/app/features/user-management/user-management.component";
import { KeycloakStateService } from 'src/app/core/service/utility.service';


@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
  @Input() sidebarActive = false;
  @Output() toggleSidebar = new EventEmitter();
  isDropdownVisible = false;
  userHasAccess = false;
  constructor(public router: Router, private dialog: MatDialog, private keycloakStateService: KeycloakStateService) { }

  ngOnInit() {
    this.keycloakStateService.observeRealmRoles().subscribe(roles => {
      console.log('Header roles:', roles);
      this.userHasAccess = roles.some(role => role.toLowerCase() === 'ztaas_admin');
    });
  }

  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter" || event.key === " ") {
      this.toggleSidebar.emit();
    }
  }

  hasZtaasAccess(): boolean {
    return this.userHasAccess;
  }


  openUserManagement() {
    if (this.userHasAccess) {
      this.dialog.open(UserManagementComponent, { width: '1000px', height: '700px' });
    } else {
      alert('Unauthorized');
    }
  }


}
